import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

export default function ScrollableTabsButtonPrevent() {  
  var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
  var selectedCourse = localStorage.getItem('etlSelectCourse');
  var mySelectedCourses = []
  if(localStorage.getItem('etlMyCourses') && localStorage.getItem('etlMyCourses').length>0){ 
	  mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
  }
  const [value, setValue] = React.useState(0);
  const [tabList, setTabList] = React.useState([]);

  React.useEffect(() => {
    let tabsArr = [];
    if(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].dashboard===1){
      tabsArr.push({url:'dashboard',title:'Dashboard'});
    }
    if(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].studyMaterial===1){
      tabsArr.push({url:'studymaterials',title:'Study Material'});
    }
    if(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].selfTest===1){
      tabsArr.push({url:'selfassessor',title:'Smart Learning'});
    }
    if(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].topicTest===1){
      tabsArr.push({url:'selecttopictest',title:'Topic Test'});
    }
    if(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].mockTest===1){
      tabsArr.push({url:'selectmocktest',title:'Exam Test'});
    }
    if(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].classTest===1 && etlStudentObj && etlStudentObj.schools && etlStudentObj.schools[0] && etlStudentObj.schools[0].schoolId>0){
      tabsArr.push({url:'selectclasstest',title:'Class Test'});
    }
    if(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].report===1){
      tabsArr.push({url:'report',title:'Report & Analytic'});
    }
    if(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].teacherHelp===1){
      tabsArr.push({url:'liveclass',title:'My Teacher Help'});
    }

    if(tabsArr.length>0){
      for(let t=0; t<tabsArr.length; t++){
        if(tabsArr[t] && window.location.pathname.indexOf(tabsArr[t].url)>-1){ 
          setValue(t);
        }
      }
    }  

    // if(tabsArr.length>0){
    //   for(let t=0; t<tabsArr.length; t++){
    //     if(tabsArr[t] && window.location.pathname.indexOf(tabsArr[t].url)>-1){ 
    //       ///setValue(t);
    //       let selectedTabItem = tabsArr.splice(t, 1);
    //       //alert(JSON.stringify(selectedTabItem));
    //       tabsArr.unshift(selectedTabItem[0]);
    //       break;  
    //     }
    //   }
    // }    


    // if(tabsArr.length>0){
    //   let tabsNewArr = [];
    //   for(let t=0; t<tabsArr.length; t++){
    //     if(tabsArr[t] && window.location.pathname.indexOf(tabsArr[t].url)>-1){ 
    //       tabsNewArr.push(tabsArr[t]);
    //       for(let u=t+1; u<tabsArr.length; u++){
    //         tabsNewArr.push(tabsArr[u]);
    //       }
    //       for(let v=0; v<t; v++){
    //         tabsNewArr.push(tabsArr[v]);
    //       }
    //     }
    //   }
    //   tabsArr = tabsNewArr;
    // }  
    
    setTabList(tabsArr);
    
  }, []);

  const handleChange = (event, newValue) => {
    ///alert('tab: '+newValue);
    if(tabList && tabList.length>0){
      for(let t=0; t<tabList.length; t++){
        if(newValue===t && tabList[t]){ 
          window.location.href = tabList[t].url;
        }
      }
    }
  };

  return (
    <Box sx={{marginTop:7, maxWidth: '98vw', display: 'flex', justifyContent:'center',}} >
      {(tabList.length>0)?
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        //scrollButtons={false}
        //allowScrollButtonsMobile
        aria-label="scrollable prevent tabs example"        
      >
        {
          tabList.map((myObj,i)=>(
            <Tab key={'tb'+i} label={myObj.title} style={{fontSize:12}} />
          ))
        }
      </Tabs>
      :null}
    </Box>
  );
}